import { ControlledButtonHook } from "commons/hooks/useControlledButton";

import TableFooter from "commons/ui/datatable/TableFooter";
import TablePagination from "commons/ui/datatable/TablePagination";

import numeral from "commons/utils/numeral";

type PropsType = {
    readonly setPage: React.Dispatch<React.SetStateAction<number>>;
    readonly exportXlsxListButton?: ControlledButtonHook;
    readonly dontShowExportXlsxButton?: boolean;
    readonly totalElements: number;
    readonly page: number;
    readonly extraButtons?: JSX.Element;
    readonly colSpan: number;
    readonly rowsPerPage: number;
};

function DataTableFooter({
    setPage,
    exportXlsxListButton,
    dontShowExportXlsxButton,
    totalElements,
    page,
    extraButtons,
    colSpan,
    rowsPerPage,
}: PropsType) {
    if (
        totalElements <= rowsPerPage &&
        !extraButtons &&
        (exportXlsxListButton === undefined || dontShowExportXlsxButton)
    ) {
        return null;
    }

    return (
        <TableFooter
            colSpan={colSpan}
            tablePagination={
                totalElements > rowsPerPage ? (
                    <TablePagination
                        count={totalElements}
                        onChangePage={(number: number) => {
                            setPage(number);
                        }}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        labelDisplayedRows={(from: number, to: number, count: number) =>
                            `${numeral(from).format("0,0")}-${numeral(to).format("0,0")} di ${
                                count !== -1
                                    ? numeral(count).format("0,0")
                                    : numeral(to).format("0,0")
                            }`
                        }
                    />
                ) : undefined
            }
            exportXlsxListButton={exportXlsxListButton}
            dontShowExportXlsxButton={dontShowExportXlsxButton}
            extraButtons={extraButtons}
        />
    );
}

export default DataTableFooter;
